export default __webpack_public_path__ + "static/media/151-graphs.a3905579.png";